export default __webpack_public_path__ + "static/media/medium.05dcfb4f.svg";